import PackageJson from '../package.json'
import debug from 'Helper/debugHelpers'
import globalConfig from 'Helper/configHelpers'
export const History = require('history').createBrowserHistory()

// initialize global config object
// import config from index.html
globalConfig.init(PackageJson.version)
globalConfig.chromeExtension = 'kncgabokabmifenpocadbjcjnblohdfp'

// Update path used by webpack (only if it exists... it wont when running tests)
if (typeof __webpack_public_path__ !== 'undefined') {
  __webpack_public_path__ = globalConfig.basepath + 'dist/'
  }
  
  const { activeLogLevel, heap_id: heapId } = globalConfig

  if(heapId) {
    // load Heap
    window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","identifyHashed","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};
    heap.load(heapId);
  }

// configure console logger
const logLevels = [
  { name: 'AUTH', color: 'orange' },
  { name: 'WINDOW_LOCK', color: 'orange' },
  { name: 'WAITLIST', color: 'green' },
  { name: 'APPCONFIG', color: 'orange' },
  { name: 'API', color: 'blue' },
  { name: 'USERMGMT', color: 'green' },
  { name: 'FP_SCAN', color: 'green' },
  { name: 'EXTENSION', color: 'green' },
  { name: 'WINDOW_MESSAGE', color: 'green' },
  { name: 'LOCAL.STORAGE', color: 'orange' },
  { name: 'SESSION.STORAGE', color: 'orange' }
]

debug.init({
  activeLevel: activeLogLevel,
  logLevels
})

// // configure API
// xtractAPI.init({
//   callbacks: apiCallbacks,
//   errorHandlers,
//   logLevel: debug.logLevels.API,
//   streamStoreName: 'streams',
//   maxFailCount: 6,
//   okToSubmitCalls
// })
